import getIn from 'transmute/getIn';
import { ValueForKeyPath } from 'immutable-less/transmute';

interface getIn {
  <Data, KeyPath extends readonly any[]>(
    keyPath: KeyPath,
    data: Data
  ): ValueForKeyPath<KeyPath, Data>;
  <KeyPath extends readonly any[]>(
    key: KeyPath
  ): <Data>(data: Data) => ValueForKeyPath<KeyPath, Data>;
}

export default getIn as getIn;
